export default "__VITE_ASSET__9ba0ce35__"